import { useState } from "react";
import EditHotelDrawer from "./EditHotelDrawer";
import getCsrfToken from "../../../clients/features/get_csrfToken";
import { useParams } from "react-router-dom";

export default function HotelHeader({ data, refreshData }) {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const { hotelId } = useParams();
  const handleSave = async (updatedData) => {

  const csrfToken = await getCsrfToken();

    await fetch(`https://api.komorotel.com/api/hotels/${hotelId}`, {
        method: "PUT",
        credentials: "include",
        headers: {
        "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData)
    });

    refreshData();
    };
  return (
    <div className="modern-card d-flex justify-content-between align-items-center">

      <div>
        <h2 className="fw-bold m-0">{data.name}</h2>
        <span className="text-muted">{data.city}, {data.island}</span>
      </div>

      <button onClick={() => setIsEditOpen(true)} className="modern-button">
        Modifier
      </button>
      
      <EditHotelDrawer
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        data={data}
        onSave={handleSave}
        />

    </div>
  );
}